import styles from './search-user.module.scss';

type Props = {
    user: { id: number; name: string; email: string };
};

const UserResult = ({ user }: Props) => (
    <li role="user-option" data-id={user.id}>
        <span className={styles.main}>{user.name}</span>
        <span className={styles.secondary}>{user.email}</span>
    </li>
);

export { UserResult };
